export type FlightPrebookErrorType = "EXPIRY" | "GENERIC";

export class FlightPrebookErrorState extends Error {
  type: FlightPrebookErrorType;

  constructor(
    type: FlightPrebookErrorType,
    message: string,
    options?: { cause?: unknown }
  ) {
    super(message, options);
    this.name = "FlightPrebookErrorState";
    this.type = type;
  }
}
